<div class="bg-shui-base-3 flex justify-between items-center gap-8 p-2 rounded-md" [class.flex-wrap]="summary()">
    <sh-select
        class="w-24 hidden md:block"
        label="Items per page"
        [condensed]="true"
        [options]="pageSizeOptionsObjects()"
        [formControl]="pageSizeControl"
    ></sh-select>
    <div class="flex flex-wrap items-center justify-end gap-x-4 gap-y-2" [class.ml-auto]="summary()">
        @if (summary()) {
            <span class="text-sm text-shui-text-strong" data-testid="paginator-summary">{{ summary() }}</span>
        }
        <sh-pagination
            [attr.pages]="Math.ceil(totalItems() / pageSize())"
            [attr.current-page]="currentPage()"
            (clicked-page-move)="goToPageEvent($event)"
            (next-page-move)="nextPage()"
            (previous-page-move)="previousPage()"
        ></sh-pagination>
    </div>
</div>
